import apiClient from "./apiClient";

export const fetchDetailedNews = async () => {
  const response = await apiClient.get("/api/slider_news/all");
  return response.data;
};

export const createDetailedNews = async (formData) => {
  const response = await apiClient.post("/api/slider_news", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return response.data;
};

export const updateDetailedNews = async (id, formData) => {
  const response = await apiClient.put(`/api/slider_news/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return response.data;
};

export const deleteDetailedNews = async (id) => {
  await apiClient.delete(`/api/slider_news/${id}`);
};


export const fetchShortNews = async () => {
  const response = await apiClient.get("/api/news/all");
  return response.data;
};

export const createShortNews = async (formData) => {
  const response = await apiClient.post("/api/news", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return response.data;
};

export const updateShortNews = async (id, formData) => {
  const response = await apiClient.put(`/api/news/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return response.data;
};

export const deleteShortNews = async (id) => {
  await apiClient.delete(`/api/news/${id}`);
};

